import { useRouter } from 'next/navigation';
import { type FC, memo } from 'react';
import { PATHS } from '@/config/paths';
import { Icon } from '@/components/elements/Icon';
import { NavigationHandler } from '@/utils/navigation';
import { PlayerButton } from './Button';

const SkipContent: FC<SkipContentProps> = ({ type, slug }) => {
  const router = useRouter();
  const navigationHandler = new NavigationHandler(router);

  const onPress = () => {
    if (!slug) return;
    navigationHandler.navigate(`${PATHS.hubs.content}/${slug}`);
  };

  return (
    <PlayerButton label="AudioMode" onClick={onPress}>
      <Icon
        iconName={type === 'prev' ? 'SkipBackOutline' : 'SkipForwardOutline'}
        color={slug ? 'white' : 'transparent'}
      />
    </PlayerButton>
  );
};

export default memo(SkipContent);

type SkipContentProps = {
  type: 'next' | 'prev';
  slug?: string;
};
